/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

export const bgLight = 'white'
export const bgDark = 'gray.950'
export const colorLight = 'gray.950'
export const colorDark = 'white'
export const secondaryLight = 'blue.900'
export const secondaryLightHover = 'blue.800'
export const secondaryDark = 'pink.600'
export const secondaryDarkHover = 'pink.650'
